import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpService } from '@core/services';
import { OpportunityDetail } from '../../../core/interface/opportunity-card-detail';

@Injectable({
  providedIn: 'root',
})
export class OpportunityCardDetailService {
  constructor(
    private readonly _httpClient: HttpService
  ) { }

  getOpportunityDetail(
    opportunityId: any,
    createdAt: string
  ): Observable<OpportunityDetail> {
    return this._httpClient.post(
      'rest/v1/rpc/get_opportunity_questions_answers',
      {
        input_opportunity_id: opportunityId,
        input_updated_at: createdAt,
      }
    );
  }

  getOpportunityDates(input_opportunity_id: string): Observable<any> {
    return this._httpClient.post(
      'rest/v1/rpc/get_meeting_created_at', {
      input_opportunity_id
    });
  }

  getMeetingSummary(meeting_bot_id: string): Observable<any> {
    return this._httpClient.get(
      `rest/v1/post_call_processed?select=summary&meeting_bot_id=eq.${meeting_bot_id}`);
  }

  getExtendedSummary(meeting_bot_id: string): Observable<any> {
    return this._httpClient.get(
      `rest/v1/post_call_processed?select=extended_summary&meeting_bot_id=eq.${meeting_bot_id}`);
  }

  getNextSteps(meeting_bot_id: string): Observable<any> {
    return this._httpClient.get(
      `rest/v1/post_call_processed?select=next_steps&meeting_bot_id=eq.${meeting_bot_id}`);
  }

  getTranscript(input_meeting_bot_id: string): Observable<any> {
    return this._httpClient.post(
      `rest/v1/rpc/get_merged_transcripts_for_opportunity`, {
      input_meeting_bot_id
    });
  }

  getMeetingRecording(meeting_bot_id: string): Observable<any> {
    return this._httpClient.post('functions/v1/get-bot-data', {
      meeting_bot_id: meeting_bot_id
    });
  }

  updateAnswer(
    questionId: string,
    meetingBotId: string,
    answer: string
  ): Observable<any> {
    const url = `rest/v1/answers?question_id=eq.${questionId}&meeting_bot_id=eq.${meetingBotId}`;
    return this._httpClient.patch(url, { answer });
  }
}
